import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { TreeSelect } from 'antd';
import useGetPaymentTermsList from '@hooks/Sales/useGetPaymentTermsList';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import ArReceiptSchedules from './ArReceiptSchedules';
import ArTransactionsLine from './ArTransactionsLine';
import { AddArTransactionSchema } from '../../../ValidationForm/validationSchema';
import { useEffect, useState } from 'react';
import useGetUnApplyPrepaymentsAr from '@hooks/AR/ArReceipts/useGetUnApplyPrepayments';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
// import { updatArTransactions, getArTransactionsById, cleanArTransactionsById } from '@store/Finance/AR/ArTransactions/ArTransactionsSlice';
import { updatArTransactions, getArTransactionsById } from '@store/Finance/AR/ArTransactions/ArTransactionsSlice';
import useGetPeopleLocationsList from '@hooks/NTX/Peoples/useGetPeopleLocationsList';
import useGetPersons from '@hooks/HR/use-get-persons';
import useGetCodeCombination from '@hooks/Finance/ChartAccountsDetails/useGetCodeCombination';
import { type UnApplyPrepaymentsModels } from '@store/Finance/AR/ArReceipts/ArReceiptsModels';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { activeFinanceSelector } from '@store/Login/authSelectors';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '../../Journals/JournalsByReference/JournalsByReference';
import ReferenceInvoiceLines from './ReferenceInvoiceLines';
// import ViewSalesOrder from './ViewSalesOrder/ViewSalesOrder';
import { callArZatca } from '@store/Finance/AR/ArTransactions/ArTransactionsSlice';
import ButtonPrint from '@components/Print/ButtonPrint';

const UpdateArTransactions = () => {
  const activeFinance = useAppSelector(activeFinanceSelector);
  const [showReferenceDetails, setShowReferenceDetails] = useState(false);
  const [showJournal, setShowJournal] = useState(false);
  const { transactionId } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // البيانات المحملة من الـ hooks
  const { Currency, loading: currencyLoading, error: currencyError } = useLookupCurrency();
  const { OperatingUnitOptions, loading: ouLoading, error: ouError } = useGetOperatingUnitWithPermission();
  const { treeCustomerData, loading: customersLoading, error: customersError } = useGetCustomersList();
  const { PaymentTermsList, loading: termsLoading, error: termsError } = useGetPaymentTermsList();
  const { PaymentMethodList, loading: methodLoading, error: methodError } = useGetPaymentMethod();
  const { dataEmployees, loading: employeesLoading, error: employeesError } = useGetPersons();
  const { GetCodeCombination } = useGetCodeCombination();

  // جلب بيانات الفاتورة
  useEffect(() => {
    if (transactionId) {
      dispatch(getArTransactionsById(transactionId));
    }
  }, [dispatch, transactionId]);

  const { ArTransactionsById: data, loading, error } = useAppSelector(a => a.ArTransactions);
  const { zatcaBusy, zatcaError, zatcaLastMessage } = useAppSelector(a => a.ArTransactions);

  // console.log(data);

  const referenceLines = data?.invoiceLineList ?? []; //
  const hasReferenceLines = referenceLines?.length > 0;
  // تحديد إذا كانت الفاتورة مرحلة
  const isPosted = data?.postedFlag === true;
  // التحقق من نوع المرجع
  const hasSalesOrder = data?.referenceType === 'Sales_Order'; // أمر مبيعات
  const hasPOS = data?.referenceType === 'Sale_Order_POS'; // نقطة بيع
  const has_R_POS = data?.referenceType === 'Sale_Returns_POS'; // نقطة بيع

  // فلاج منع التعديل
  const NotEditable = hasSalesOrder || hasPOS || isPosted;

  // console.log(JSON.stringify(data.invoiceLineList));

  //#region Formik
  const formik = useFormik({
    initialValues: {
      transactionNum: data?.transactionNum ?? '',
      peopleId: data?.peopleId ?? '',
      transactionType: data?.transactionType ?? '',
      referenceType: data?.referenceType ?? '',
      referenceId: data?.referenceId ?? '',
      transactionDate: data?.transactionDate?.split('T')[0] ?? '',
      organizationId: data?.organizationId ?? '',
      paymentTermsId: data?.paymentTermsId ?? '',
      paymentMethodId: data?.paymentMethodId ?? '',
      currencyCode: data?.currencyCode ?? 'SAR',
      currencyConversionRate: data?.currencyConversionRate ?? 1,
      includeVatFlag: data?.includeVatFlag ?? true,
      salesrepId: data?.salesrepId ?? '',
      billToCustomerId: data?.billToCustomerId ?? '',
      shipToCustomerId: data?.shipToCustomerId ?? '',

      arTransactionLinesList:
        data?.arTransactionLinesList?.map(item => ({
          id: item.id,
          lineNumber: item.lineNumber,
          lineType: item.lineType,
          invItemId: item.invItemId,
          uom: item.uom,
          description: item.description,
          price: item.price,
          qty: item.qty,
          discountRate: item.discountRate,
          discountAmount: item.discountAmount,
          vatRate: item.vatRate,
          total: item.total,
          vatAmount: item.vatAmount,
          currencyCode: data.currencyCode ?? '',
          currencyConversionRate: data.currencyConversionRate ?? '',
          purHeaderId: null,
          purLineId: null,
          accountId: item.accountId,
          costCenterId: item.costCenterId,
          branchId: item.glBrunchId,
          companyId: item.glCompanyId,
          codeCombination: GetCodeCombination(item.glCompanyId, item.glBrunchId, item.accountId, item.costCenterId)
        })) ?? [],

      arReceiptSchedulesList:
        data?.arReceiptSchedulesList?.map(item => ({
          id: item.id,
          amount: item.amount,
          dueDate: item.dueDate?.split('T')[0],
          paymentId: item.receiptId,
          invoicePaymentId: item.transactionReceiptId,
          paymentCode: item.codeReceipt,
          paymentDate: new Date(item.receiptDate).toLocaleDateString(),
          paymentAmount: item.amountReceipt,
          // ~~ الحقول ادناه في حال كانت الدفعة عادية (غير مقدمة) وهي للعرض فقط ~~~~~~~
          AmountPaid: item.receiptId === null ? item.amountReceipt : 0,
          RemainingAmount: item.receiptId === null ? item.amount - (item.amountReceipt || 0) : 0
        })) ?? []
    },

    enableReinitialize: true,
    validationSchema: AddArTransactionSchema(t, activeFinance),
    // validationSchema: AddArTransactionSchema(t),
    onSubmit: values => {
      // منع التعديل إذا كانت الفاتورة مرحلة
      if (isPosted) {
        CustomAlert({ action: 'info', msg: t('لا يمكن تعديل الفواتير بعد الترحيل') });
        formik.setSubmitting(false);
        return;
      }

      const { arTransactionLinesList, arReceiptSchedulesList } = values;

      if (arTransactionLinesList?.length === 0) {
        SwalAlert({ text: 'لا يمكن متابعة العملية بدون إضافة بنود للفاتورة، يرجى إضافة البنود.' });
        formik.setSubmitting(false);
        return;
      }

      const totalTransactionLines = arTransactionLinesList?.reduce((sum: number, item: any) => sum + item.total, 0);
      const totalReceiptSchedules = arReceiptSchedulesList?.reduce(
        (sum: number, payment: any) => sum + Number(payment.amount),
        0
      );

      if (arReceiptSchedulesList?.length > 0 && totalTransactionLines !== totalReceiptSchedules) {
        SwalAlert({ text: 'لا يتطابق مجموع الفاتورة مع مجموع الجدولة. يرجى المراجعة.' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        updatArTransactions({
          id: data.id,
          transactionNum: values.transactionNum,
          transactionDate: values.transactionDate,
          paymentTermsId: values.paymentTermsId,
          paymentMethodId: values.paymentMethodId,
          salesrepId: values.salesrepId,
          billToCustomerId: values.billToCustomerId,
          shipToCustomerId: values.shipToCustomerId,

          transactionsLinesList: values.arTransactionLinesList?.map((line: any, idx) => ({
            id: line.id,
            lineNumber: ++idx,
            lineType: line.lineType,
            invItemId: line.invItemId,
            uom: line.uom || null,
            description: line.description,
            price: line.price || 0,
            qty: line.qty || 0,
            discountRate: line.discountRate || 0,
            discountAmount: line.discountAmount || 0,
            vatRate: line.vatRate || 0,
            total: line.total,
            vatAmount: line.vatAmount || 0,
            accountId: line.accountId,
            costCenterId: line.costCenterId
          })),

          receiptSchedulesList:
            values.arReceiptSchedulesList?.map((item: any) => ({
              id: item.id,
              amount: item.amount,
              dueDate: item.dueDate,
              receiptId: item.paymentId,
              transectionReceiptId: item.invoicePaymentId
            })) || null
        })
      )
        .unwrap()
        .then((res: any) => {
          console.log(res);
          if (res.succeeded) {
            CustomAlert({ action: 'Edit' });
          } else {
            CustomAlert({ action: 'Error', msg: res.message });
            formik.setSubmitting(false);
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue } = formik;
  //#endregion

  const { hasPrepayments, totalPrepaymentAmount, UnApplyPrepaymentsList } = useGetUnApplyPrepaymentsAr({
    PeopleId: values.peopleId
  });

  const { billToLocation, shipToLocation } = useGetPeopleLocationsList({
    peopleId: values.peopleId
  });

  // حساب المبلغ المتبقي للدفعة المقدمة
  useEffect(() => {
    const updatedPayments = formik.values.arReceiptSchedulesList.map(item => {
      const paymentAmountUnApply = item.paymentId
        ? (UnApplyPrepaymentsList?.find(f => f.id === item.paymentId)?.amountUnApply ?? 0)
        : 0;

      return {
        ...item,
        PaymentAmountUnApply: !isPosted ? paymentAmountUnApply + (item.amount ?? 0) : paymentAmountUnApply
      };
    });

    formik.setFieldValue('arReceiptSchedulesList', updatedPayments);
  }, [UnApplyPrepaymentsList, isPosted]);

  // تحديث القيمة المتبقية من قائمة الدفعات المتبقية
  const [unApplyPrepayments, setUnApplyPrepayments] = useState<UnApplyPrepaymentsModels[]>([]);
  useEffect(() => {
    const updatedPrepayments = UnApplyPrepaymentsList?.map(prepayment => {
      const matchingItem = data?.arReceiptSchedulesList?.find(item => item.receiptId === prepayment.id);

      if (matchingItem) {
        const paymentAmountUnApply = matchingItem.receiptId ? (prepayment.amountUnApply ?? 0) : 0;
        return {
          ...prepayment,
          amountUnApply: paymentAmountUnApply + (matchingItem.amount ?? 0)
        };
      }
      return prepayment;
    });

    setUnApplyPrepayments(updatedPrepayments);
  }, [UnApplyPrepaymentsList, data?.arReceiptSchedulesList]);

  // تحديد إعدادات Alert بناءً على النوع
  const getReferenceAlertConfig = () => {
    if (hasSalesOrder) {
      return {
        show: true,
        icon: 'fas fa-shopping-cart',
        title: t('فاتورة مرتبطة بأمر مبيعات'),
        message: t('هذه الفاتورة صادرة بناءً على أمر المبيعات رقم'),
        referenceNumber: data?.referenceId || '',
        buttonText: t('عرض التفاصيــل'),
        alertClass: 'alert-warning'
      };
    } else if (hasPOS) {
      return {
        show: true,
        icon: 'fas fa-cash-register',
        title: t('فاتورة نقطة بيع'),
        message: t('هذه الفاتورة تمثل بيعًا من نقطة البيع '),
        // referenceNumber: data?.referenceId || '',
        referenceNumber: '',
        buttonText: t('عرض تفاصيل'),
        alertClass: 'alert-info'
      };
    } else if (has_R_POS) {
      return {
        show: true,
        icon: 'fas fa-cash-register',
        title: t('مردودات نقاط البيع'),
        message: t(''),
        // referenceNumber: data?.referenceId || '',
        referenceNumber: '',
        buttonText: t('عرض تفاصيل '),
        alertClass: 'alert-info'
      };
    }

    return {
      show: false,
      icon: '',
      title: '',
      message: '',
      referenceNumber: '',
      buttonText: '',
      alertClass: ''
    };
  };

  const referenceAlertConfig = getReferenceAlertConfig();

  // عرض المحتوى المناسب في المودال بناءً على النوع
  const renderModalContent = () => {
    const title = hasSalesOrder ? 'تفاصيل أمر البيع' : hasPOS ? 'تفاصيل نقطة البيع' : 'تفاصيل المرجع';

    return (
      <div className='p-0'>
        <div className='p-4 border-bottom'>
          <h5 className='mb-1'>{title}</h5>
          <div className='text-muted'>
            رقم المرجع: <span className='fw-bold text-primary'>{'-'}</span>
          </div>
        </div>

        <ReferenceInvoiceLines
          lines={referenceLines}
          title={hasSalesOrder ? 'تفاصيل أمر البيع (المرجع)' : 'تفاصيل نقطة البيع (المرجع)'}
          badgeText={hasSalesOrder ? 'بنود أمر البيع' : 'بنود نقطة البيع'}
          maxTableHeight='420px'
        />
      </div>
    );
  };

  //#region   هيئة الزكاة والضريبة
  // const canUseZatca = !!transactionId && data && data.skipZatca !== true;
  const canUseZatca = !!transactionId && data;

  const onZatca = (action: 'sync' | 'send' | 'refresh') => {
    if (!transactionId) return;

    if (!canUseZatca) {
      CustomAlert({ action: 'info', msg: t('تم تعطيل الزاتكا لهذه الفاتورة (skipZatca)') });
      return;
    }

    dispatch(callArZatca({ id: transactionId, action }))
      .unwrap()
      .then(r => {
        CustomAlert({ action: 'Add', msg: r.message || t('تمت العملية بنجاح') });
      })
      .catch(err => {
        CustomAlert({ action: 'Error', msg: String(err || zatcaError || t('حدث خطأ')) });
      });
  };
  //#endregion

  // حالات التحميل والأخطاء المجمعة
  const isLoading =
    loading || currencyLoading || ouLoading || customersLoading || termsLoading || methodLoading || employeesLoading;
  const hasError = error || currencyError || ouError || customersError || termsError || methodError || employeesError;

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'ReceivableInvoices',
              link: '/AR/ArTransactions'
            },
            {
              name: 'InvoiceDetails',
              link: null
            }
          ]}
          PageName='InvoiceDetails'
        />
                <div className='ms-auto'>
                  <div className='col-5 col-md-6 text-end'>
                    <ButtonPrint
                      PrintTemplateTypeId='0642FEBE-1EC0-4B42-B663-C11BAABA52D2' // قوالب فواتيــر الإستحقاق
                      ReferenceId={data?.id || ''}
                    />
                  </div>
                </div>
      </div>

      <Loading loading={isLoading} error={hasError}>
        <Card>
          {data && !hasPOS && false && (
            <div className='alert alert-light d-flex align-items-center justify-content-between m-2'>
              <div className='d-flex align-items-center gap-3'>
                {/* <i className='fas fa-qrcode fa-2x text-theme'></i> */}
                 <div>
                  <div className='fw-bold'>
                    {t('هيئة الزكاة والضريبة')}
                    {data.skipZatca ? (
                      <span className='badge bg-secondary ms-2'>{t('مستبعد')}</span>
                    ) : (
                      <span className='badge bg-success ms-2'>{t('مفعل')}</span>
                    )}
                  </div>

                  <div className='small text-muted'>
                    {t('نوع المستند')}: <span className='fw-bold'>{data.zatcaDocType ?? '-----'}</span>
                    <span className='mx-2'>•</span>
                    {t('الحالة')}: <span className='fw-bold'>{data.zatcaStatus ?? '-----'}</span>
                  </div>
                </div>
              </div>

              <div className='d-flex gap-2'>
                {/* زر المزامنة الأساسي */}
                <button
                  type='button'
                  className='btn btn-sm btn-theme'
                  disabled={!canUseZatca || zatcaBusy !== null}
                  onClick={() => onZatca('sync')}
                >
                  {zatcaBusy === 'sync' ? (
                    <span className='spinner-border spinner-border-sm me-2'></span>
                  ) : (
                    <i className='fas fa-sync-alt me-2'></i>
                  )}
                  {t('مزامنة زاتكا')}
                </button>

                {/* (اختياري) تحديث الحالة */}
                {/* <button
                  type='button'
                  className='btn btn-sm btn-theme'
                  disabled={!canUseZatca || zatcaBusy !== null}
                  onClick={() => onZatca('refresh')}
                >
                  {zatcaBusy === 'sync' ? (
                    <span className='spinner-border spinner-border-sm me-2'></span>
                  ) : (
                    <i className='fas fa-sync-alt me-2'></i>
                  )}
                  {t('مزامنة زاتكا')}
                </button> */}

                {/* (اختياري) إرسال */}
                {/* <button
                  type='button'
                  className='btn btn-sm btn-theme'
                  disabled={!canUseZatca || zatcaBusy !== null}
                  onClick={() => onZatca('send')}
                >
                  {zatcaBusy === 'sync' ? (
                    <span className='spinner-border spinner-border-sm me-2'></span>
                  ) : (
                    <i className='fas fa-sync-alt me-2'></i>
                  )}
                  {t('مزامنة زاتكا')}
                </button> */}
              </div>
            </div>
          )}

          {isPosted && (
            <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
              <div className='d-flex align-items-center'>
                <i className='fas fa-info-circle fa-2x me-3'></i>
                <div>
                  <h5 className='mb-1'>{t('الفاتورة مرحلة')}</h5>
                  <p className='mb-0'>{t('لا يمكن تعديل الفواتير بعد ترحيلها في النظام')}</p>
                </div>
              </div>

              <button type='button' className='btn btn-sm btn-info' onClick={() => setShowJournal(true)}>
                <i className='fa fa-info-circle fa-fw me-1'></i>
                {t('عرض القيد')}
              </button>
            </div>
          )}

          {data?.referenceType && (
            <div
              className={`alert ${referenceAlertConfig.alertClass} d-flex align-items-center justify-content-between m-2`}
              hidden={!referenceAlertConfig.show}
            >
              <div className='d-flex align-items-center'>
                <i className={`${referenceAlertConfig.icon} fa-2x me-3`}></i>
                <div>
                  <h5 className='mb-1'>{referenceAlertConfig.title}</h5>
                  <p className='mb-0'>
                    {referenceAlertConfig.message}
                    <span className='fw-bold text-primary mx-2'>{referenceAlertConfig.referenceNumber}</span>
                  </p>
                </div>
              </div>

              <button
                type='button'
                className={`btn btn-sm ${referenceAlertConfig.alertClass.replace('alert-', 'btn-')}`}
                onClick={() => setShowReferenceDetails(true)}
              >
                <i className='fa fa-eye fa-fw me-1'></i>
                {referenceAlertConfig.buttonText}
              </button>
            </div>
          )}

          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row'>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('InvoiceDate')}</label>
                    <Form.Control
                      disabled={isPosted}
                      className='form-control'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                      isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    <div className='text-danger small'>{touched.transactionDate && errors.transactionDate}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('InvoiceType')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='transactionType'
                      onChange={formikhandleChange}
                      value={values.transactionType || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      <option value='Standard'>{i18n.language === 'en' ? 'Standard' : 'قياسي'}</option>
                      <option value='CreditMemo'>{i18n.language === 'en' ? 'Credit Memo' : 'إشعار دائن'}</option>
                    </Form.Select>
                    <div className='text-danger small'>{touched.transactionType && errors.transactionType}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('OperatingUnit')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={false}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Customer')}</label>
                    <TreeSelect
                      disabled
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.peopleId}
                      onChange={option => {
                        formik.setFieldValue('peopleId', option === null ? null : option);
                      }}
                      treeData={treeCustomerData}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('CustomerInvoiceNumber')}</label>
                    <Form.Control
                      disabled={NotEditable}
                      autoComplete='off'
                      className='form-control text-center'
                      type='text'
                      name='transactionNum'
                      onChange={formikhandleChange}
                      value={values.transactionNum || ''}
                      isInvalid={!!(touched.transactionNum && errors.transactionNum)}
                    />
                    <div className='text-danger small'>{touched.transactionNum && errors.transactionNum}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('BillingLocation')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='billToCustomerId'
                      onChange={formik.handleChange}
                      value={formik.values.billToCustomerId || ''}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {billToLocation?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.billToCustomerId && errors.billToCustomerId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('ShippingLocation')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='shipToCustomerId'
                      onChange={formik.handleChange}
                      value={formik.values.shipToCustomerId || ''}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {shipToLocation?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.shipToCustomerId && errors.shipToCustomerId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('SalesRepresentative')}</label>
                    <Select
                      isDisabled={isPosted}
                      classNamePrefix='react-select'
                      isLoading={false}
                      isSearchable={true}
                      isClearable
                      name='salesrepId'
                      options={dataEmployees}
                      value={dataEmployees?.find((f: any) => f.value === formik.values.salesrepId)}
                      onChange={(option: any) => {
                        formik.setFieldValue('salesrepId', option?.value || '');
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.salesrepId && errors.salesrepId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentTerms')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='paymentTermsId'
                      onChange={formik.handleChange}
                      value={formik.values.paymentTermsId || ''}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PaymentTermsList?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.paymentTermsId && errors.paymentTermsId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentMethod')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='paymentMethodId'
                      onChange={formik.handleChange}
                      value={formik.values.paymentMethodId || ''}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PaymentMethodList?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.paymentMethodId && errors.paymentMethodId}</div>
                  </div>
                </div>

                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Currency')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='currencyCode'
                      onChange={formikhandleChange}
                      value={values.currencyCode}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {Currency?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.currencyCode}>
                          {item.description}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
                  </div>
                </div>

                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('CurrencyConversionRate')}</label>
                    <Form.Control
                      className='form-control text-center'
                      autoComplete='off'
                      readOnly
                      value={values.currencyConversionRate || '1'}
                    />
                  </div>
                </div>
              </div>

              <div className='alert alert-primary' hidden={!hasPrepayments || isPosted}>
                <i className='fas fa-lg fa-exclamation-circle me-2'></i>
                <strong> {t('Reminder')}</strong> {t('هذا العميـل لديه دفعات مقدمة بإجمالي:')}
                <span className='ms-2 text-success fw-bold fs-5'>{totalPrepaymentAmount}</span>
              </div>
            </CardBody>

            <CardFooter className='mt-2 mb-2 p-0'>
              <ul className='nav nav-tabs p-0'>
                <li className='nav-item border-3 border-theme'>
                  <Link to='#arTransactionLines' className='nav-link active' data-bs-toggle='tab'>
                    <i className='fas fa-file-invoice me-2 text-theme'></i>
                    {t('InvoiceLines')}
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link to='#arReceiptSchedules' className='nav-link' data-bs-toggle='tab'>
                    <i className='fas fa-calendar-alt me-2 text-theme'></i>
                    {t('InvoiceSchedule')}
                  </Link>
                </li>
                {(hasSalesOrder || hasPOS) && (
                  <li className='nav-item'>
                    <Link to='#referenceLines' className='nav-link' data-bs-toggle='tab'>
                      <i className='fas fa-link me-2 text-theme'></i>
                      {i18n.language === 'ar' ? 'بنود المرجع' : 'Reference Lines'}
                    </Link>
                  </li>
                )}
              </ul>

              <div className='tab-content py-4 px-0'>
                <div className='tab-pane fade show active' id='arTransactionLines'>
                  {/* <ArTransactionsLine formik={formik} NotEditable={NotEditable || false} /> */}
                  <ArTransactionsLine formik={formik} />
                </div>

                <div className='tab-pane fade' id='arReceiptSchedules'>
                  <ArReceiptSchedules
                    formik={formik}
                    UnApplyPrepaymentsList={unApplyPrepayments}
                    // NotEditable={NotEditable || false}
                  />
                </div>

                {(hasSalesOrder || hasPOS) && (
                  <div className='tab-pane fade' id='referenceLines'>
                    <ReferenceInvoiceLines
                      lines={referenceLines}
                      title={hasSalesOrder ? 'تفاصيل أمر البيع (المرجع)' : 'تفاصيل نقطة البيع (المرجع)'}
                      badgeText={hasSalesOrder ? 'بنود أمر البيع' : 'بنود نقطة البيع'}
                      maxTableHeight='420px'
                    />
                  </div>
                )}
              </div>

              {formik.errors.arReceiptSchedulesList?.length && (
                <div className='text-danger'> {t('InvoiceScheduleRequired')}</div>
              )}

              <div className='text-center mt-2'>
                <button
                  disabled={formik.isSubmitting || isPosted}
                  type='submit'
                  className='btn btn-lg me-1 btn-theme mb-1'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fa fa-save fa-fw me-1'></i>
                  )}
                  {t('Save')}
                </button>
                <button
                  type='button'
                  className='btn btn-lg me-1 btn-default mb-1'
                  onClick={() => navigate('/AR/ArTransactions', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </CardFooter>
          </Form>
        </Card>
      </Loading>

      <NeatixModal show={showJournal} setShow={setShowJournal} size='xl' title='تفاصيــل القيد'>
        {transactionId && <JournalsByReference referenceId={transactionId} />}
      </NeatixModal>

      <NeatixModal
        show={showReferenceDetails}
        setShow={setShowReferenceDetails}
        size='xl'
        showHeader={false}
        bodyClassName='p-0'
        centered
      >
        {showReferenceDetails ? renderModalContent() : null}
      </NeatixModal>
    </>
  );
};

export default UpdateArTransactions;
